export default __webpack_public_path__ + "static/media/dislike_selected.2303d8da.svg";